import { Typography, Box } from "@mui/material";

const Header = ({ title }) => {
  return (
    <Box>
      <Typography variant="h3" fontWeight="bold">
        {title}
      </Typography>
    </Box>
  );
};

export default Header;
